<template>
  <div class="bt-anggota pa-5">
    <KelompokWakaf target="transaksi/dashboard" :list="list" @refreshKelompok="getKelompokWakaf"
      :total_wakaf="total_wakaf" :is_show_total_wakaf="true" />
  </div>
</template>
<script>
import Header from "@/components/Header";
import KelompokWakaf from "@/components/KelompokWakaf.vue";
import Toast from "@/components/Toast";
import services from "@/services";
import helper from "@/utils/helper";
import { mapGetters } from "vuex";
export default {
  name: "WakafKelompok",
  components: {
    KelompokWakaf,
    Toast,
    Header,
  },
  data() {
    return {
      list: {
        loading: false,
        kelompok: [],
        cm_code: null,
        branch_id: null,
        transaction_date: null,
        fa_code: null,
        account_cash_code: null,
      },
      total_wakaf: 0,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...helper,
    async getKelompokWakaf(cm_code, branch_id, transaction_date) {
      cm_code = cm_code || this.$route.params.cm_code;
      branch_id = branch_id || this.$route.params.branch_id;
      transaction_date = transaction_date || this.$route.params.tanggal;

      const fa_code = this.user.fa_code || null;
      const account_cash_code = this.user.account_cash_code || null;

      let payload = new FormData();
      payload.append("cm_code", cm_code);
      payload.append("branch_id", branch_id);
      payload.append("transaction_date", transaction_date);
      payload.append("fa_code", fa_code);
      payload.append("account_cash_code", account_cash_code);

      try {
        this.list.loading = true;
        const response = await services.infoGroupWakaf(
          payload,
          this.user.token
        );
        if (response.status === 200) {
          const { kelompok = [], total_wakaf = 0 } = response.data.data;
          this.list.kelompok = kelompok;
          this.total_wakaf = total_wakaf;
        } else {
          this.$store.dispatch("showAlert", {
            show: false,
            msg: "",
          });
          setTimeout(() => {
            this.$store.dispatch("showAlert", {
              show: true,
              msg: response.message,
              color: "error",
              position: "top",
            });
          }, 50);
        }
      } catch (error) {
        this.$store.dispatch("showAlert", {
          show: false,
          msg: "",
        });
        setTimeout(() => {
          this.$store.dispatch("showAlert", {
            show: true,
            msg: error,
            color: "error",
            position: "top",
          });
        }, 50);
      } finally {
        this.list.loading = false;
      }
    },
    getDate() {
      let today = new Date();
      let day = today.getDate();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      return `${year}-${month}-${day}`;
    },
  },
  mounted() {
    this.getKelompokWakaf(false, false, false);
    this.list.cm_code = this.$route.params.cm_code;
    this.list.branch_id = this.$route.params.branch_id;
    this.list.transaction_date = this.$route.params.tanggal;
    this.list.fa_code = this.$route.params.fa_code;
  },
};
</script>
